import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { DestinoTransportistas } from '../models/DestinoTransportistas';


@Injectable({
    providedIn: 'root'
})
export class DestinoTransportistasService {

    private url = "";
    private apiEndpoint = environment.destinoTransportistasUrl;


    constructor(private readonly httpClient:HttpClient) { }

    getDestinoTransportistasTable(): Observable<DestinoTransportistas[]> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.get<DestinoTransportistas[]>(this.url).pipe(
          map((res: DestinoTransportistas[]) => {
            return res.map((destinoTransportistas) => DestinoTransportistas.transformDestinoTransportistas(destinoTransportistas))
          })
        );
    }

    getDistinctTransporte(): Observable<String[]> {
      this.url = this.apiEndpoint + "/distinctActiveRelationshipTransporte";
      console.log(this.url);
      return this.httpClient.get<String[]>(this.url).pipe(
      );
    }

    getDistinctDestino(): Observable<String[]> {
      this.url = this.apiEndpoint + "/distinctActiveRelationshipDestino";
      console.log(this.url);
      return this.httpClient.get<String[]>(this.url).pipe(
      );
    }


    addUpdate(destinoTransportistas: DestinoTransportistas, add: boolean): Observable<DestinoTransportistas> {
        if (add) {
          console.log("Add");
          console.log(destinoTransportistas);
          return this.add(destinoTransportistas);
        } else {
          console.log("Update");
          console.log(destinoTransportistas);
          return this.update(destinoTransportistas);
        }
      }

      add(destinoTransportistas: DestinoTransportistas): Observable<DestinoTransportistas> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.post<DestinoTransportistas>(this.url, destinoTransportistas).pipe(
          map((res: any) => {
            return DestinoTransportistas.transformDestinoTransportistas(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for destino transportistas: " + destinoTransportistas);
            return throwError(err);
          })
        );
      }

      update(destinoTransportistas: DestinoTransportistas): Observable<DestinoTransportistas> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.put<DestinoTransportistas>(this.url, destinoTransportistas).pipe(
          map((res: any) => {
            return DestinoTransportistas.transformDestinoTransportistas(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for destino transportistas: " + destinoTransportistas);
            console.log(destinoTransportistas);
            return throwError(err);
          })
        );
      }
}
